import { createApp } from 'vue'
import FButton from '~/js/components/button'
import FSlider from '~/js/components/slider'
import FModal from '~/js/components/modal'
import MLens from '~/js/components/lens'
import { isDesktop } from '~/js/templates/index/helpers'
import { isApp } from '~/js/helpers/user-agent-helper'
import { setEventScroll, CLASS_NAME_SCROLL_TRIGGER } from '../../helpers/scroll'

export const initProductMediaViewer = (element) => {
  const app = createApp({
    name: 'TemplatesProductMediaViewer',
    components: {
      FButton,
      FSlider,
      FModal,
      MLens,
    },
    data() {
      return {
        heightSlider: null,
        isApp: isApp(),
        isDesktop: isDesktop(),
        selectedIndex: 0,
        zoomElement: null,
      }
    },
    computed: {
      showZoom() {
        return !!this.zoomElement
      },
    },
    mounted() {
      const elementMediaSlider = this.$refs['media-slider']
      if (elementMediaSlider) {
        const width = elementMediaSlider.clientWidth
        this.heightSlider = width

        const elementsVideo = elementMediaSlider.getElementsByTagName('video')
        const elementsImage = elementMediaSlider.getElementsByTagName('img')
        ;[...elementsVideo, ...elementsImage].forEach(
          (element) => (element.style.height = `${width}px`)
        )
      }

      this.elementModelViewer = this.$refs.modelViewer
      this.setEventDotClicked()
      this.setEventScroll()
    },
    methods: {
      open3dModel(url) {
        if (this.elementModelViewer.canActivateAR) {
          this.elementModelViewer.activateAR()
        } else {
          location.href = url
        }
      },
      setElement($event) {
        if (!isDesktop()) return
        const element = $event.target
        if (!element.hasAttribute('is-image')) return
        const elementImage = element.querySelector('img')
        this.zoomElement = elementImage
      },
      resetElement() {
        this.zoomElement = null
      },
      setEventDotClicked() {
        const elementDotsWrapper = this.$el.querySelector('.slick-dots')
        if (!elementDotsWrapper) return
        const elementsDot = elementDotsWrapper.querySelectorAll('button')
        Array.from(elementsDot).forEach((element, index) => {
          element.addEventListener('click', () => {
            this.onCurrentIndexChanged(index)
          })
        })
      },
      setEventScroll() {
        const elementsScrollTrigger = document.getElementsByClassName(
          CLASS_NAME_SCROLL_TRIGGER
        )
        if (elementsScrollTrigger.length)
          Array.from(elementsScrollTrigger).forEach((element) => {
            setEventScroll(element)
          })
      },
      onCurrentIndexChanged(index) {
        this.selectedIndex = index
        const thumbnailWrapper = this.$refs.thumbnailWrapper
        const thumbnailItem = thumbnailWrapper.querySelectorAll('li')[index]

        if (thumbnailItem.offsetLeft < thumbnailWrapper.scrollLeft) {
          thumbnailWrapper.scrollTo({
            left: thumbnailItem.offsetLeft,
            behavior: 'smooth',
          })
        } else if (
          thumbnailWrapper.scrollLeft + thumbnailWrapper.clientWidth <
          thumbnailItem.offsetLeft
        )
          thumbnailWrapper.scrollTo({
            left:
              thumbnailItem.offsetLeft +
              thumbnailItem.clientWidth -
              thumbnailWrapper.clientWidth,
            behavior: 'smooth',
          })
      },
      onThumbnailItemClicked($event) {
        const item = $event.target.closest('li')
        const parentElement = item.parentElement
        const childlen = parentElement.querySelectorAll('li:not([style])')
        const index = Array.prototype.indexOf.call(childlen, item)
        this.selectedIndex = index
      },
    },
  })
  app.config.compilerOptions.isCustomElement = (tag) => {
    return tag === 'model-viewer'
  }
  app.mount(element)
}
